var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"categories-title"},[_c('ElementIconText',{attrs:{"text":_vm.title,"icon":_vm.icon}}),(_vm.showTag)?_c('ElementTag',{attrs:{"text":String(_vm.number),"color":"yellow"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }